import { Radio as RadioAria } from "react-aria-components";
import type { RadioProps } from "react-aria-components";
import React from "react";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

export function Radio2({ className, ...radioProps }: RadioProps) {
  return <RadioAria className={cn(body(), className)} {...radioProps} />;
}

const useRadioStyles = tv({
  slots: {
    body: cn(
      "tw:flex! tw:cursor-pointer tw:items-center tw:gap-3 tw:font-body tw:text-text-secondary",

      "tw:before:flex tw:before:size-4 tw:before:shrink-0 tw:before:rounded-full",
      "tw:before:mb-0.5 tw:before:bg-fill-white tw:before:transition-colors tw:before:content-['']!",
      "tw:before:ring-1 tw:before:ring-stroke-secondary",
      "tw:before:border-3 tw:before:border-stroke-white",

      "tw:selected:before:bg-fill-teal-primary",
      "tw:hover:before:bg-fill-teal-primary",

      "tw:focus-visible:before:outline-2 tw:focus-visible:before:outline-offset-4",
      "tw:focus-visible:before:outline-stroke-bright-purple-secondary",

      "tw:disabled:cursor-not-allowed tw:disabled:opacity-50",
      "tw:disabled:before:bg-fill-tertiary",
    ),
  },
});

const { body } = useRadioStyles();
